module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('m-header', {
    attrs: {
      "title": _vm.$route.params.title
    }
  }), _vm._v(" "), (_vm.list.length == 0) ? _c('no-data', {
    attrs: {
      "imgPic": "couponList"
    }
  }) : _vm._e(), _vm._v(" "), _c('list', {
    attrs: {
      "list": _vm.list
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06b47f10"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HomeCoupon/HomeCoupon.vue
// module id = 510
// module chunks = 0